export const getWatermarkScale = ({
    textWidth,
    textHeight,
    pageWidth,
}: {
    textWidth: number;
    textHeight: number;
    pageWidth: number;
}): number => {
    if (textWidth <= 0) {
        return 1;
    }
    const rotatedExtent = (textWidth + textHeight) / Math.SQRT2;
    return Math.min(1, pageWidth / rotatedExtent);
};
